import {initialState} from "./reducer";
import {createSelector} from "reselect";

const selectState = state => state.get('addDocumentType', initialState);

const selectFieldTypes = createSelector(
    selectState,
    fieldTypesState =>
        fieldTypesState.get('fieldTypes')
            ? fieldTypesState
                .get('fieldTypes')
                .toJS()
            : [],
);

const selectServices = createSelector(
    selectState,
    docPopupState =>
        docPopupState.get('services')
            ? docPopupState
                .get('services')
                .toJS()
            : [],
);

export const makeSelectFieldTypes = () => selectFieldTypes;
export const makeSelectServices = () => selectServices;
